import _ from 'lodash';

const Collection = {
  add(collection, models) {
    const copy = [...collection];
    const singular = !_.isArray(models);
    models = singular ? (models ? [models] : []) : _.clone(models);

    // Loop over the array and try to add them to the collection.
    _.each(models, (model) => {
      // Make sure this is a unique item. If there is already a match, fail this.
      const unique = _.find(copy, { id: model.id });
      if (!_.isUndefined(unique)) return;
      if (_.isUndefined(copy)) return;
      copy.push(model);
    });
    return copy;
  },

  // all(collection) {
  // },
  addMany(collection, changedObjects) {
    let newCollection = [...collection];
    const add = () => {
      for (let changedObject of changedObjects) {
        newCollection = this.add(newCollection, changedObject);
      }
      return newCollection;
    };
    return add();
  },

  removeAndAdd(collection, changedObject) {
    const copy = [...collection];
    const tempCollection = this.remove(copy, changedObject);
    const newCollection = this.add(tempCollection, changedObject);
    return newCollection;
  },

  reset(collection, data) {
    const emptyCollection = this.removeAll(collection);
    const newCollection = this.add(emptyCollection, data);
    return newCollection;
  },

  get(collection, id) {
    const copy = [...collection];
    return _.find(copy, { id });
  },

  where(collection, context) {
    if (_.isEmpty(context) || collection.length === 0) return [];
    // Filter the collection
    const copy = [...collection];
    const results = _.filter(copy, context);
    return results;
  },

  update(collection, id, changedObject, options = {}) {
    // Find the correct entry and update it with the new info
    let copy = [...collection];
    const existing = _.find(copy, { id });
    // Create a new object instead of mutating the existing one
    const model = { ...existing, ...changedObject };

    // Remove the old object and add the new one
    copy = _.reject(copy, { id });
    copy.push(model);
    return copy;
  },

  updateMany(collection, changedObjects, options = {}) {
    let newCollection = [...collection];
    const updateCollection = () => {
      if (typeof changedObjects === 'undefined') {
        return newCollection;
      }
      for (const changedObject of changedObjects) {
        newCollection = this.update(
          newCollection,
          changedObject.id,
          changedObject,
          options,
        );
      }
      return newCollection;
    };
    return updateCollection();
  },

  remove(collection, changedObject = null, options = {}) {
    // Find the correct entry and update it with the new info
    const copy = [...collection];
    const index = _.findIndex(copy, {
      id: changedObject ? changedObject.id : options.id,
    });
    if (index !== -1) {
      // Remove the old object
      copy.splice(index, 1);
    }
    return copy;
  },

  removeMany(collection, changedObjects) {
    let copy = [...collection];
    const remove = () => {
      for (let changedObject of changedObjects) {
        copy = this.remove(copy, changedObject);
      }
      return copy;
    };
    return remove();
  },

  removeAll(collection) {
    return [];
  },

  size(collection) {
    return _.size(collection);
  },
};

export default Collection;
